
export enum EnumRole {
  // WORKSPACE_ROLE_UNKNOW = 0,
  WORKSPACE_ROLE_OWNER = 1,
  WORKSPACE_ROLE_ADMIN = 2,
  // WORKSPACE_ROLE_MANAGER = 3,
  WORKSPACE_ROLE_MEMBER = 4,
  // WORKSPACE_ROLE_VIEWER = 5,
  // WORKSPACE_ROLE_ACCOUNTANT = 6,
}

export const EnumRoleTranslation: Record<EnumRole, string> = {
  // [EnumRole.WORKSPACE_ROLE_UNKNOW]: "unknown",
  [EnumRole.WORKSPACE_ROLE_OWNER]: "Owner",
  [EnumRole.WORKSPACE_ROLE_ADMIN]: "Admin",
  // [EnumRole.WORKSPACE_ROLE_MANAGER]: "Manager",
  [EnumRole.WORKSPACE_ROLE_MEMBER]: "Member",
  // [EnumRole.WORKSPACE_ROLE_VIEWER]:"Viewer",
  // [EnumRole.WORKSPACE_ROLE_ACCOUNTANT]: "Accountant"
}
